import React from 'react'
import Link from 'gatsby-link'
import Hero from '../components/hero'
import Helmet from 'react-helmet'

const PhotoBooths = (props) => (
    <div>
        <Helmet
            title="De photobooths van Gifture PhotoBooth huur je v.a. €195 all in | Gifture"
            meta={[
                {
                    name: 'description',
                    content: `Klein maar krachtig. Dat zijn de photobooths van Gifture Photobooth. Met of zonder begeleiding en propvol unieke features!`
                },
                {
                    name: 'keywords',
                    content: [
                        'Photobooths', 'Huren', ' Trouwerij', ' Bedrijfsfeest', 'Flitskast', 'Fotokast', 'Fotohokje', 'Fotopaal'
                    ].join(',')
                },
            ]}
        />
        <Hero size="is-medium" centeredText={true} image={require('../assets/images/hero-photobooths.jpg')}>
            <div className="content">
                <h1 className="title">Voor welke <span>Photobooth</span> kies jij?</h1>
                <p>
                    Of je nu prive iets te vieren hebt of een groot evenement organiseert, onze Photobooths passen overal!
                </p>
            </div>
        </Hero>
        <div className="section">
            <div className="container">
                <div className="columns">
                    <div className="column">
                        <div className="content">
                            <h4>
                                Een PhotoBooth, VideoBooth en GifBooth in-een!
                            </h4>
                            <p>
                                Al onze Photobooths zijn klein van formaat maar groots in mogelijkheden. Altijd voorzien van een accupack waardoor ze volledig draadloos zijn, voorzien van felle LED verlichting en altijd de beste apparatuur voor de hoogst mogelijke kwaliteit.
                            </p>
                            <p>
                                Wil je de leukste foto’s hebben? We verhuren onze photobooth zonder begeleider. Hierdoor hebben je gasten minder het gevoel dat ze zich moeten inhouden en worden de foto’s ongeremd en gekker! Toch een enthousiaste medewerker bij de photobooth? Dat is geen enkel probleem! Onze crew bestaat uit jonge enthousiastelingen die mensen graag laten lachen! Geef jouw wensen aan bij de reservering en wij zorgen dat de fotozuil bemand is voor de duur van jouw evenement. En wat doen onze entertainers? Zij zorgen voor enorm veel enthousiasme, foute ideeën en de gekste accessoires en voorwerpen.
                            </p>
                            <p>
                                Een photobooth huren kan bij ons al vanaf € 195,- all in. Dat wil zeggen: onbeperkt collage's en boomerangs maken, bij een onbemande photobooth geen tijdslimiet (tot een maximum van 24 uur), bezorging en installatie binnen een straal van 50km vanaf ons kantoor in Leidschendam, gratis props, onbeperkt SMSen en achteraf ontvang je alle foto’s direct via WeTransfer!
                            </p>
                        </div>
                    </div>
                    <div className="column image">
                        <img src="http://placehold.it/500x275?text=Hier+komt+de+introfilm" alt=""/>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="hero is-primary">
                <div className="hero-body">
                    <div className="has-text-centered">
                        <h2 className="title">Altijd een photobooth die geschikt is voor jouw evenement!</h2>
                    </div>
                </div>
            </div>

        </div>
        <div className="section">
            <div className="container">
                <div className="columns is-multiline is-mobile">
                    <div className="column">
                        <div className="card">
                            <div className="card-image">
                                <div className="image">
                                    <img src={require('../assets/images/IMG_6328.jpg')} />
                                </div>
                            </div>
                            <div className="card-content">
                                <div className="media">
                                    <div className="media-content">
                                        <p className="title is-4">Gifture Retro Photobooth</p>
                                        <p className="subtitle is-6">vanaf €195,- all in</p>
                                    </div>
                                </div>

                                <div className="content">
                                    Met het huren van een Gifture Booth haal je een selfiestation in huis met chique looks! Klein, supersnel en vol unieke functies, het is echt een ware pretmachine! Hoogglans zwart met gouden details, geïntegreerd touchscreen en zonder kabels over de vloer. De afmeting zijn 40x40x50 cm (lxbxh) en heeft een verstelbare poot die van 130cm tot op een hoogte van 190cm kan worden gebracht. Gasten kunnen zelfstandig de leukste foto’s maken!
                                    <br /><br />
                                    <strong> Altijd delen! Met of zonder wifi op locatie!</strong> <br />
                                    Aangezien onze booth standaard niet print maar de bezoekers wel graag hun foto willen ontvangen hebben we een altijd delen principe. Is er geen stabiele wifi verbinding aanwezig op de locatie? Als je dit tijdens het reserveren aangeeft dan kunnen we zorgen voor een mobiele wifi hotspot! Zo kunnen we zelfs op de meest afgelegen locatie zorgen dat de foto’s direct gedeeld kunnen worden.
                                    <ul>
                                        <li>De snelste installatie ooit! Uitpakken, opzetten en activeren binnen 5 minuten! Zoek een
                                            mooi plekje uit en profiteer van deze blikvanger tijdens jouw evenement!
                                        </li>
                                        <li>Activeer de gepersonaliseerde template of kies uit een standaard template</li>
                                        <li>Bekijk een voorbeeld van uw foto’s voor u ze print</li>
                                        <li>Deel foto’s direct op social media d.m.v. SMS links!</li>
                                        <li>De print module kan tijdens het bestellen geactiveerd worden!</li>
                                    </ul>
                                    <p>
                                        <Link className="button is-primary" to="/reserveren">Huur de Gifture Retro Booth</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card">
                            <div className="card-image">
                                <div className="image">
                                    <img src={require('../assets/images/coming-soon.jpg')} />
                                </div>
                            </div>
                            <div className="card-content">
                                <div className="media">
                                    <div className="media-content">
                                        <p className="title is-4">Gifture Event Photobooth (vanaf januari 2018)</p>
                                        <p className="subtitle is-6">vanaf €595,- all in</p>
                                    </div>
                                </div>

                                <div className="content">
                                    <p>
                                        Wie kent ze niet, de fotograven op events en festivals! Onwijs leuk achteraf maar weinig social media exposure op het moment zelf! Dat moet anders kunnen vinden wij!
                                        <br /><br /> Daarom introduceren wij de Gifture Event Booth. De enige portable photobooth van Nederland. Gaat waar jou gasten gaan en up-and-running binnen 1 minuut! Een enthousiaste medewerker loopt vol energie rond op jouw evenement of feest met een zeer kleine maar krachtige photobooth!
                                        <br /><br /> Deze photobooth komt dus naar jouw gasten toe in plaats van andersom! Het principe is het zelfde als bij zijn grotere broer, met het enige verschil dat deze booth wordt bediend door onze medewerker. Dankzij de spiegel aan de achterkant van de booth weten de bezoekers wat de camera ziet. Er kunnen 1 tot 4 foto’s gemaakt worden die volledig in style van het evenement gebracht kunnen worden. Dan is het tijd om de booth te draaien en het eindresultaat aan de gasten te laten zien. Zijn ze tevreden? Dan ontvangen zij binnen enkele minuten een link per SMS waar zij de foto kunnen downloaden en delen op hun eigen social media!
                                        <br /><br /> Ook deze booth is volledig draadloos en kan tot 8 uur actief gebruikt worden. De scherpe LED verlichting op deze booth zorgt ervoor dat er ook foto’s gemaakt kunnen worden op locaties met iets minder verlichting. Geen prints maar wel hele vette foto’s en GIF animaties die net zo aanstekelijk zijn! De creaties zijn eenvoudig te delen op Facebook, Instagram,  en Whatsapp.
                                    </p>
                                    <p>
                                        <button className="button is-primary" disabled>Huur de Gifture Event Booth</button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column is-full">
                        <div className="has-text-centered content">
                            <hr/>
                            <h4>
                                &#8226; Geweldige features voor legendarische feestjes! &#8226;
                            </h4>
                            {/*<p>*/}
                                {/*<Link className="button is-danger" to="/eigenschappen">Bekijk alle eigenschappen</Link>*/}
                            {/*</p>*/}
                            <div className="columns is-multiline">
                                <div className="column is-one-third is-full-mobile">
                                    <p>
                                        <strong>
                                            Collages
                                        </strong>
                                        <br/>
                                        We maken een aantal foto's en maken er een mooie collage van. Het kader van de collage
                                        kan volledig naar eigen wens opgemaakt worden!
                                    </p>
                                </div>
                                <div className="column is-one-third is-full-mobile">
                                    <p>
                                        <strong>
                                            Boomerangs (Gif)
                                        </strong>
                                        <br />
                                        We nemen een videoclip op van +- 4 seconden, versnellen de clip en zetten het om naar een GIFje.
                                        Het resultaat van het gif-filmpje kan direct op Social Media gepost worden!
                                    </p>
                                </div>
                                <div className="column is-one-third is-full-mobile">
                                    <p>
                                        <strong>
                                            Video gastenboek
                                        </strong>
                                        <br/>
                                        Laat een persoonlijke boodschap achter voor de ontvanger. Bedank de gastheer / gastvrouw voor de leuke avond
                                        of wens het nieuwe bruidspaar veel geluk toe in hun nieuwe leven!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default PhotoBooths;



// WEBPACK FOOTER //
// ./src/pages/gifture-photobooths.js